module.exports = __webpack_public_path__ + "static/media/plan-mas-400-gigas-wom76.944cf312.svg";